import React, { PureComponent } from 'react';
import { Field, FieldArray, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { groupBy } from 'lodash';
import { get, post, put } from '../../redux/modules/news';
import FieldInput from '../../components/Field/Field';
import GalleryInput from '../../components/gallery-input';
import FieldCheckbox from '../../components/Field/FieldCheckbox';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';
import DatePicker from '../../components/date-picker/DatePicker';
import DynamicField from '../../components/dynamic-field';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

class PartnerForm extends PureComponent {

  mapSections = (sections = []) => {
    const backup = sections.map((obj, index) => {
      obj.position = index;
      return obj;
    });
    const result = groupBy(backup, 'component');

    return {
      section_images: result.Image || [],
      section_texts: result.Text || [],
      section_lists: result.List || []
    };
  };

  handlerSubmit(values = {}) {
    const { getAction, putAction, postAction, close } = this.props;
    const sectionsObj = this.mapSections(values.sections);
    const newData = { ...values, ...sectionsObj };

    if (newData.is_soon !== true) {
      newData.is_soon = false;
    }

    if ((newData.gallery || []).length > 0) {
      newData.gallery = JSON.stringify(newData.gallery);
    } else {
      newData.gallery = '[]';
    }

    if (newData.id > 0) {
      return putAction(newData.id, newData)
        .then(() => {
          close();
          getAction();
        });
    }
    return postAction(newData).then(() => {
      close();
      getAction();
    });
  }

  render() {
    const { myValues, handleSubmit, pristine, reset, submitting } = this.props;
    const isSoon = !myValues.is_soon;
    return (
      <form
        className="planet-form notice-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="planet-form__container">
          <div className="row">
            <div className="col-md-4">
              <Field
                label="Title"
                name="title"
                validate={[Validations.required, Validations.minLength2]}
                component={FieldInput}/>

              <Field
                label="Sub title"
                name="sub_title"
                validate={[Validations.required, Validations.minLength2]}
                component={FieldInput}/>

              <Field
                label="Very Soon"
                name="is_soon"
                type="checkbox"
                component={FieldCheckbox}/>
              {
                isSoon && <Field
                  label="Start Date"
                  name="start_date"
                  validate={[Validations.required]}
                  component={DatePicker}/>
              }
              {
                isSoon && <Field
                  label="End Date"
                  name="end_date"
                  validate={[Validations.required]}
                  component={DatePicker}/>
              }
            </div>
            <div className="col-md-3">
              <label>Main Image</label>
              <Field
                validate={[Validations.required, Validations.minLength2]}
                name="image"
                component={Image}/>
            </div>

            <div className="col-md-5">
              <FieldArray
                name="gallery"
                component={GalleryInput}/>
            </div>

            <div style={{ margin: '0 13px' }}>
              <div className="row">
                <div className="col-md-12">
                  <Field
                    name="body"
                    validate={[Validations.required, Validations.minLength2, Validations.maxMediumText]}
                    component={Editor}/>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <DynamicField myValues={myValues}/>
              </div>
            </div>

            <div className="clearfix"></div>
            <div className="col-lg-12 text-right form-buttons">
              <button disabled={pristine || submitting} loading={submitting} type="submit"
                      className="btn  btn-primary btn-xl">Save
              </button>
              <button disabled={pristine || submitting} loading={submitting} type="button"
                      className="btn btn-primary btn-xl"
                      onClick={reset}>Clear
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues || {}
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/notice/index.js